import { render, staticRenderFns } from "./RecentAddendum.vue?vue&type=template&id=69dc1a09&scoped=true&"
import script from "./RecentAddendum.vue?vue&type=script&lang=js&"
export * from "./RecentAddendum.vue?vue&type=script&lang=js&"
import style0 from "./RecentAddendum.vue?vue&type=style&index=0&id=69dc1a09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69dc1a09",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69dc1a09')) {
      api.createRecord('69dc1a09', component.options)
    } else {
      api.reload('69dc1a09', component.options)
    }
    module.hot.accept("./RecentAddendum.vue?vue&type=template&id=69dc1a09&scoped=true&", function () {
      api.rerender('69dc1a09', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/addendum/RecentAddendum.vue"
export default component.exports